import LoadingButton from "../common/LoadingButton.jsx";
import { TRAINER_REGISTRATION_PAGES } from "../../constants/trainer-registration-page-constants.js";
import { Checkbox } from "primereact/checkbox";
import React, { useState, useEffect } from "react";
import { getCurrentLanguage } from "../../helpers/languageHelper.js";
const TrainerRegistrationFormFooter = ({
  isSubmitted,
  isSubmitting,
  invalidForm,
  formElement,
  onBack,
  onBackSubPage,
  onNext,
  onNextSubPage,
  onSubmit,
  handleNextSubPage,
  onApprovePolicy,
  isApprovedPolicy,
  disabled
}) => {

  const [isApprovedPolicyState, setIsApprovedPolicyState] = useState(isApprovedPolicy);
  const lang = getCurrentLanguage();

  useEffect(() => {
    onApprovePolicy(isApprovedPolicyState);
  }, [isApprovedPolicyState]);
  if (!isSubmitted) {
    return (
      <div className="action-button md:justify-content-end justify-content-center flex-wrap md:flex-nowrap">
        <div className="right-buttons flex-wrap md:flex-nowrap w-full md:w-auto">
          <div className="w-full md:w-auto keduall-typography text-16-semibold-600 flex align-items-center justify-content-center gap-2">
            <Checkbox
              className="keduall-checkbox checkbox-policy"
              onChange={e => setIsApprovedPolicyState(e.checked)}
              checked={isApprovedPolicyState}
              disabled={disabled}
            />
            {disabled ? (
              <span className="text-secondary-txt">{formElement.sixthFormPage.instructionPolicyLabel}</span>
            ) : (
              <a href={`/${lang}/instructor-policy`} target="_blank" rel="noreferrer">{formElement.sixthFormPage.instructionPolicyLabel}</a>
            )}
          </div>
          <button
            type="button"
            className="w-full md:w-auto keduall-buttons button-text-default-normal-secondary keduall-typography text-16-semibold-600"
            onClick={() => onSubmit()}
            disabled={disabled}
          >
            <span>{formElement.actionButton.saveDraft}</span>
          </button>
          <LoadingButton
            onClick={() => onSubmit(false)}
            loading={isSubmitting}
            disabled={!isApprovedPolicyState}
            label={formElement.actionButton.submit}
            className="w-full md:w-auto keduall-buttons button-filled-default-normal-primary keduall-typography text-16-semibold-600 text-white-txt"
          />
        </div>
      </div>
    );
  }

  // Success page - submitted
  if (isSubmitted) {
    return (
      <div className="action-button justify-content-center align-items-center">
        <div className="flex-wrap md:flex-nowrap">
          <button
            className="keduall-buttons button-filled-default-normal-primary keduall-typography text-16-semibold-600 text-white-txt"
            onClick={() => { window.location.href = "/"; }}
          >
            <span>{formElement.lastFormPage.backToHomeButtonLabel}</span>
          </button>
        </div>
      </div>
    );
  }

  // Default fallback
  return null;
};

export default TrainerRegistrationFormFooter;